export type BadgeCategory =
  | "general"
  | "tasks"
  | "notes"
  | "fitness"
  | "community"
  | "social"
  | "account";

export type BadgeRarity = "common" | "uncommon" | "rare" | "epic" | "legendary";

export const RARITY_COLORS: Record<BadgeRarity, string> = {
  common: "#9e9e9e",
  uncommon: "#4caf50",
  rare: "#2196f3",
  epic: "#9c27b0",
  legendary: "#ff9800",
};

export const RARITY_LABELS: Record<BadgeRarity, string> = {
  common: "Common",
  uncommon: "Uncommon",
  rare: "Rare",
  epic: "Epic",
  legendary: "Legendary",
};

export type Badge = {
  id: string;
  title: string;
  description: string;
  icon: string;
  category: BadgeCategory;
  rarity: BadgeRarity;
};

export type BadgeStatus = Badge & {
  unlocked: boolean;
  unlockedAt?: string;
  progress?: number; // 0–1
  progressLabel?: string; // e.g. "5 / 10"
};

export type BadgeData = {
  loginCount: number;
  longestLoginStreak: number;
  currentLoginStreak: number;
  taskCount: number;
  tasksCompleted: number;
  noteCount: number;
  workoutSessions: number;
  liftEntries: number;
  totalVolumeKg: number;
  communityPosts: number;
  familyMembers: number;
  hasPremium: boolean;
  hasCustomTheme: boolean;
  hasCustomNav: boolean;
  isEarlyAdopter: boolean;
  isBetaTester: boolean;
  hasReferral: boolean;
  daysOnApp: number;
  dailyLogCount: number;
  listCount: number;
  bodyWeightEntries: number;
  cardioEntries: number;
};

export const BADGE_CATEGORY_META: Record<BadgeCategory, { label: string; icon: string }> = {
  general: { label: "General", icon: "fa-solid fa-star" },
  tasks: { label: "Tasks", icon: "fa-solid fa-check-double" },
  notes: { label: "Notes", icon: "fa-solid fa-pen-fancy" },
  fitness: { label: "Fitness", icon: "fa-solid fa-dumbbell" },
  community: { label: "Community", icon: "fa-solid fa-users" },
  social: { label: "Social", icon: "fa-solid fa-share-nodes" },
  account: { label: "Account", icon: "fa-solid fa-user-gear" },
};
